import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from 'src/app/store/state/app.state';
import { ImportExcelSheet } from 'src/app/store/actions/material.action';

@Injectable({
  providedIn: 'root'
})
export class ImportExcelSheetService {

  constructor(public apiService: ApiService,
              private store: Store<IAppState>,) { }

  importExcelSheet(body : any): Observable<any> {
    return this.apiService.post('Sheet/importSheet', body)
  }
 
}
